export default __webpack_public_path__ + "static/media/salesintel.7a2407d6.svg";